export function moveTowards(current: number, target: number, speed: number): number {
    const difference = target - current;
    
    if (Math.abs(difference) <= speed) {
        return target;
    }
    
    return current + Math.sign(difference) * speed;
} 